package com.arenaproplay.admin.ui.components.overlay

import androidx.compose.runtime.Composable
import com.arenaproplay.admin.ui.theme.AppColors
import com.arenaproplay.admin.ui.theme.AppTypography
import com.arenaproplay.admin.ui.utils.Constants
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.*

val ModalFadeInKeyframes = Keyframes {
    from {
        Modifier.opacity(0).scale(0.9)
    }
    to {
        Modifier.opacity(1).scale(1)
    }
}

val ModalOverlayFadeInKeyframes = Keyframes {
    from {
        Modifier.opacity(0)
    }
    to {
        Modifier.opacity(1)
    }
}

@Composable
fun Modal(
    isOpen: Boolean,
    onClose: () -> Unit,
    modifier: Modifier = Modifier,
    title: String? = null,
    maxWidth: CSSLengthOrPercentageNumericValue = 500.px,
    closeOnOverlayClick: Boolean = true,
    content: @Composable () -> Unit
) {
    if (!isOpen) return

    val colorMode = ColorMode.current
    val colors = AppColors.getColors(colorMode)

    Box(
        modifier = Modifier
            .position(Position.Fixed)
            .top(0.px).left(0.px).right(0.px).bottom(0.px)
            .zIndex(1000)
            .backgroundColor(colors.overlay)
            .onClick { if (closeOnOverlayClick) onClose() }
            .animation(
                ModalOverlayFadeInKeyframes.toAnimation(
                    duration = Constants.ANIMATION_FAST.ms,
                    timingFunction = AnimationTimingFunction.EaseOut
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        Box(
            modifier = modifier
                .maxWidth(maxWidth)
                .fillMaxWidth()
                .margin(leftRight = 16.px)
                .backgroundColor(colors.surface)
                .borderRadius(16.px)
                .padding(24.px)
                .onClick { it.stopPropagation() }
                .animation(
                    ModalFadeInKeyframes.toAnimation(
                        duration = Constants.ANIMATION_NORMAL.ms,
                        timingFunction = AnimationTimingFunction.EaseOut
                    )
                )
                .styleModifier {
                    property("box-shadow", "0 24px 48px rgba(0, 0, 0, 0.3)")
                }
        ) {
            Column(Modifier.fillMaxWidth().gap(16.px)) {
                if (title != null) {
                    Row(
                        Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.SpaceBetween,
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        SpanText(
                            text = title,
                            modifier = Modifier
                                .fontSize(AppTypography.H5)
                                .fontWeight(FontWeight.SemiBold)
                                .color(colors.textPrimary)
                        )
                        Box(
                            modifier = Modifier
                                .size(32.px)
                                .borderRadius(50.percent)
                                .cursor(Cursor.Pointer)
                                .backgroundColor(colors.surfaceVariant)
                                .onClick { onClose() },
                            contentAlignment = Alignment.Center
                        ) {
                            SpanText(
                                "\u00D7",
                                modifier = Modifier
                                    .fontSize(20.px)
                                    .color(colors.textSecondary)
                            )
                        }
                    }
                }

                content()
            }
        }
    }
}
